import axios from 'axios'
import { MessageBox } from 'element-ui'
// let processPath = process.env.NODE_ENV
// let API_PATH = ''
// let host = window.location.host
// if (host.indexOf('localhost') !== -1) {
//   API_PATH = ''
// } else if (host === 'player-dev.jkwwt.cn' || host === 'euc-player-dev.boringkiller.cn') {
//   API_PATH = process.env.API_PATH_DEV
// } else {
//   API_PATH = process.env.API_PATH_PROD
// }
const instance = axios.create({
  // baseURL: processPath === 'production' ? 'http://api-dev.jkwwt.cn' : '',
  baseURL: process.env.BASE_API,
  headers: {
    'Content-type': 'application/json'
  },
  timeout: 10000
})

// 请求拦截器

instance.interceptors.request.use(config => {
  if (localStorage.getItem('auth_token')) {
    config.headers.common['Authentication-token'] = localStorage.getItem('auth_token')
  }
  return config
})

// 响应拦截器
instance.interceptors.response.use(response => {
  // 没权限到登陆页
  if (response.data.code === 401) {
    MessageBox({
      title: response.data.msg,
      message: '请重新登录？',
      center: true,
      type: 'warning'
    }).then(() => {
      window.location.href = '/'
    }).catch(() => {})
  }
  return response.data
}, err => {
  if (err.message.indexOf('404') > 0) {
    MessageBox({
      title: '请求404！',
      message: '无效访问！',
      center: true,
      type: 'error',
      showClose: false
    })
    return
  }
  if (err.message.indexOf('500') > 0) {
    MessageBox({
      title: '请求500！',
      message: '请联系管理员',
      center: true,
      type: 'error',
      showClose: false
    })
    return
  }
  if (err.message.indexOf('502') > 0) {
    MessageBox({
      title: '请求502！',
      message: '请联系管理员',
      center: true,
      type: 'error',
      showClose: false
    })
    return
  }
  return Promise.reject(err)
})

export default instance



// WEBPACK FOOTER //
// ./src/service/http.config.js